"use client";
import { ReactNode, useCallback, useMemo } from "react";

import { getEventName } from "@stadium/helpers/analytics";

import useAnalyticsActionEvents from "@stadium/services/analytics/hooks/use-action-events";

import { useJuneSoContext } from "@stadium/services/june-analytics/provider";

import { getEventTargetLocation } from "@stadium/services/june-analytics/helpers";

import { JuneSoEventPropsType } from "@stadium/services/june-analytics/prop-types.d";

const defaultObj = {};
const defaultArr = [];

export type TrackEventArgumentsTypes = {
  eventProperties?: JuneSoEventPropsType;
  target?: ReactNode | string;
  action?: string;
  elementPosition?: string;
  componentName?: string;
};

export const useJuneSoEventTracking = ({
  services = defaultArr,
}: {
  services: readonly string[];
}) => {
  const { trackEvent: _trackEvent } = useAnalyticsActionEvents(services);
  const { currentUserData } = useJuneSoContext();
  const groupId = currentUserData?.company?.id;
  const companyName = currentUserData?.company?.name;

  const trackEvent = useCallback(
    ({
      componentName = "",
      elementPosition = "",
      eventProperties = defaultObj,
      target = null,
      action = "clicked",
    }: TrackEventArgumentsTypes) => {
      if (componentName || elementPosition) {
        return _trackEvent({
          eventName: getEventName({
            targetLocation: getEventTargetLocation({ componentName, elementPosition }),
            target,
            action,
          }),
          eventProperties,
          context: { groupId },
          additionalProps: { companyName },
        });
      }
    },
    [groupId],
  );

  return useMemo(() => ({ trackEvent }), [trackEvent]);
};
